import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Breadcrumb } from '@types-custom/models/ui/breadcrumb-model';

@Component({
  selector: 'audit-breadcrumb',
  templateUrl: './audit-breadcrumb.component.html',
  styleUrls: ['./audit-breadcrumb.component.scss'],
})
export class AuditBreadcrumbComponent implements OnInit {
  @Input() breadcrumbs$: Breadcrumb[] = [];
  @Output() handleClick = new EventEmitter<any>();

  ngOnInit(): void {
  }

  eventClick(url: string) {
    this.handleClick.emit(url);
  }


}
